import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import Loader from '../components/loader/Loader'
import { setVideoCache } from '../slices/assetCacheSlice'
import { cacheImages, cacheVideos } from './cacheHelper'

export const images = {
  mainBg:
    'https://lesa2021.s3.ap-southeast-1.amazonaws.com/_uploads/LESA+ASB+Robot_FINAL-min.jpg',
}

const videos = [
  {
    filename: 'introVid',
    url: 'https://lesa2021.s3.ap-southeast-1.amazonaws.com/_uploads/lesa2023-final-720p.mp4',
  },
]

const PreCache = ({ skipVid, children }) => {
  const [isImgCached, setIsImgCached] = useState(false)
  const [isVidCached, setIsVidCached] = useState(false)
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    cacheImages(Object.values(images))
      .then(() => {
        setIsImgCached(true)
        console.log('cached images')
      })
      .catch((error) => {
        console.log(error)
      })

    cacheVideos(videos).then((cachedVids) => {
      dispatch(setVideoCache(cachedVids))
      setIsVidCached(true)
    })
  }, [dispatch])

  useEffect(() => {
    if (isImgCached && isVidCached) {
      setLoading(false)
    }
  }, [dispatch, isImgCached, isVidCached])

  return <>{loading ? <Loader intro skipVid={skipVid}/> : children}</>
}

export default PreCache
